<div #mainDiv_ll_loanmgmt_loanrecord>
  <div *ngIf="bundle.function === 'bbc'">
    <div *ngIf="bundle.BBCLOGONAME != ''"
         [style.top.px]="5"
         [style.left.px]="bundle.spX + 10"
         style="position: absolute;">
      <img [style.max-width.px]="150"
           [style.max-height.px]="35"
           style="width: auto; height: auto;"
           [src]="bundle.BBCLOGONAME">
    </div>
    <div class="txtNorm12"
         [style.top.px]="bundle.spY - 15"
         [style.left.px]="bundle.spX + 37"
         [style.width.px]="bundle.spW - (bundle.spX)"
         [style.overflowY]="'auto'"
         style="position: absolute;">
      <div>{{ bundle.COLLATCONFIGMSG }}</div>
    </div>
  </div>

  <div *ngIf="bundle.groups && bundle.records"
       [style.top.px]="bundle.spY"
       [style.left.px]="bundle.spX"
       [style.height.px]="bundle.spH"
       [style.width.px]="bundle.spW"
       [style.overflowY]="'auto'"
       [ngClass]="{'group-list': true, 'config-unlocked': !bundle.configLock}"
       style="position: absolute;">
    <ul>
      <ng-container *ngFor="let group of sortGroupsByOrder(bundle.groups)">
        <div class="group-container">
        <li class="group-header-row" [ngClass]="{'no-gear': group.GROUPCANEDITYESNO === 'No'}" *ngIf="getRecordCountForGroup(group.LOANGROUPID) === 0 || getRecordCountForGroup(group.LOANGROUPID) > 1">
          <div class="gear-column" [ngClass]="{'hidden': group.GROUPCANEDITYESNO === 'No'}">
            <img *ngIf="!bundle.configLock" class="editGear" src="assets/icon_gear.png" alt="Group action" (click)="edit(group.LOANGROUPID, $event)">
          </div>
          <div class="label-column">{{ group.GROUPNAME }}</div>
        </li>

        <ng-container *ngFor="let record of getRecordsForGroup(group.LOANGROUPID)">
          <li class="record-wrapper">
            <div class="gear-column" [ngClass]="{'hidden': group.GROUPCANEDITYESNO === 'No'}">
              <img *ngIf="getRecordCountForGroup(group.LOANGROUPID) === 1 && !bundle.configLock"
                   class="editGear" [id]="'GR' + group.LOANGROUPID"
                   src="assets/icon_gear.png" alt="Group action"
                   (click)="edit(group.LOANGROUPID, $event)">
            </div>
            <div class="label-column">
              <span class="record-label">{{ record.ELEMENTLABEL }}:</span>
              <div class="tooltip-container">
                <img class="info-btn" src="assets/infoBtn.png" alt="Info"
                     [attr.data-record-id]="record.LOANELEMENTID"
                     (mouseover)="showTooltip($event, record.LOANELEMENTID)"
                     (mouseout)="hideTooltip(record.LOANELEMENTID)">
                <div *ngIf="tooltipVisibility[record.LOANELEMENTID]"
                     class="tooltip"
                     [style.left.px]="tooltipPosition.x"
                     [style.top.px]="tooltipPosition.y">
                  {{ record.ELEMENTDESCRIPTION || 'No description available' }}
                </div>
              </div>
            </div>

            <div class="input-box" *ngIf="record.ELEMENTVALUETYPE !== 'none'">
              <ng-container *ngIf="bundle.valueLock || record.ELEMENTCANEDITYESNO === 'No'; else editableInput">
                <div class="locked-text">
                  <span class="locked-value">
                    {{ formatElementValue(record.ELEMENTVALUE, record.ELEMENTVALUETYPE) }}
                  </span>
                  <span class="locked-note"
                        [ngClass]="{'warning-note': record.ELEMENTNOTE === 'Excess of Commitment' || record.ELEMENTNOTE === 'Excess of Availability'}">
                    {{ record.ELEMENTNOTE || '' }}
                  </span>
                </div>
              </ng-container>

              <ng-template #editableInput>
                <div class="input-box">

                  <!-- Date / Number / Dropdown -->
                  <ng-container [ngSwitch]="record.ELEMENTVALUETYPE">

                    <ng-container *ngSwitchCase="'dropdown'">
                      <select class="record-input dropdown-input"
                              [value]="record.ELEMENTVALUE"
                              (change)="onDropdownChange($event, record.LOANELEMENTID)">
                        <option value="" disabled>Select option</option>

                        <!-- Use pre-computed options (now possibly with added formatted value for 119) -->
                        <option *ngFor="let opt of dropdownOptions[record.LOANELEMENTID] || []" [value]="opt">
                          {{ opt }}
                        </option>
                      </select>
                    </ng-container>

                    <input *ngSwitchCase="'date'"
                           class="record-input date-input"
                           type="date"
                           [value]="record.ELEMENTVALUE"
                           (change)="onDateInputChange($event, record.LOANELEMENTID)" />

                    <input *ngSwitchDefault
                           class="record-input"
                           type="text"
                           [value]="formattedValues[record.LOANELEMENTID]"
                           (keyup)="onInputKeyUp($event, record.LOANELEMENTID)"
                           [attr.readonly]="record.LOANELEMENTID === 69 ? 'readonly' : null" />

                  </ng-container>

                  <!-- Note field -->
                  <input class="note-input"
                         type="text"
                         [value]="record.ELEMENTNOTE"
                         (keyup)="onNoteInputKeyUp($event, record.LOANELEMENTID)"
                         placeholder="Enter note"
                         [ngClass]="{'warning-note': record.ELEMENTNOTE === 'Excess of Commitment' || record.ELEMENTNOTE === 'Excess of Availability'}" />

                </div>
              </ng-template>
            </div>
          </li>
        </ng-container>
  </div>
  </ng-container>
  </ul>

  <!-- Signature Popup -->
  <div class="signature-popup" *ngIf="showSignaturePopup"
       [style.top.px]="bundle.spY + 40"
       [style.left.px]="(bundle.spW - 600) / 2"
       [style.width.px]="600">
    <div [style.top.px]="10" [style.left.px]="10"></div>
    <div class="close-btn" (click)="closeSignaturePopup()">
      <img src="assets/icon_closeForm.png" alt="Close">
    </div>
    <div class="signature-container">
      <div *ngIf="sigType === 'client'">
        <p class="signature-text">{{ bundle.BBCLANGUAGE }}</p>
      </div>
      <div *ngIf="sigType === 'approve'">
        <p class="signature-text">{{ bundle.BBCAPPROVALLANGUAGE }}</p>
      </div>
      <div *ngIf="sigType === 'delete'">
        <p class="signature-text">Click the 'Confirm Delete' word button below to confirm that you want to delete this BBC</p>
      </div>
      <div *ngIf="sigType != 'delete'">
        <input type="text" class="signature-input" placeholder="Sign here" #signatureInput
               (input)="onSignatureInput($event)">
        <p class="signature-name">{{ bundle.CONTACTFIRST }} {{ bundle.CONTACTLAST }}</p>
        <input type="text" class="signature-title" placeholder="Title" #signatureInput
               (input)="onTitleInput($event)">
      </div>
      <div class="notice-submit">
        <p class="signature-notice" *ngIf="!bundle.sigAndTitle && sigType != 'delete'">
          Typed signature must match name below the line and Title is required
        </p>
        <div class="wordBtn14" *ngIf="sigType === 'client' && bundle.sigAndTitle" (click)="signBBC()">
          Submit
        </div>
        <div class="wordBtn14" *ngIf="sigType === 'approve' && bundle.sigAndTitle" (click)="approveBBCValues()">
          Submit Approval
        </div>
        <div class="wordBtn14" *ngIf="sigType === 'delete'" (click)="deleteBBC()">
          Confirm Delete
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Popover for elements -->
<div class="signature-popup" *ngIf="showPopover && popoverGroupId !== null"
     [style.width.px]="bundle.spW - 60"
     [style.top.px]="popoverPosition.y - 50"
     [style.left.px]="popoverPosition.x"
     (mouseout)="onPopoverMouseOut($event, popoverGroupId)">
  <div class="close-btn" (click)="closePopover()">
    <img src="assets/icon_closeForm.png" alt="Close">
  </div>
  <ul class="popover-list" (mouseover)="onPopoverMouseOver()">
    <ng-container *ngFor="let element of getElementsForGroup(popoverGroupId)">
      <li class="popover-item">
        <input type="checkbox" class="popover-checkbox"
               [checked]="isElementInRecords(element.LOANELEMENTID, element.LOANGROUPID)"
               (click)="onCheckboxClick(element.LOANELEMENTID, element.LOANGROUPID, $event)">
        <span class="popover-text">{{ element.ELEMENTLABEL + ' : ' + (element.ELEMENTDESCRIPTION || '') }}</span>
      </li>
    </ng-container>
  </ul>
</div>


<!-- Approve BBC Values -->
<div class="wordBtn"
     *ngIf="bundle.showApprovalSig"
     (click)="openSignaturePopup('approve')"
     [style.top.px]="bundle.spY + bundle.spH + 10"
     [style.left.px]="bundle.spX + 320"
     [style.width.px]="200"
     style="position: absolute; text-align: center;">
  <span>Sign and Accept BBC</span>
</div>

<!-- Sign BBC Document -->
<div *ngIf="bundle.showClientSig"
     class="wordBtn"
     (click)="openSignaturePopup('client')"
     [style.top.px]="bundle.spY + bundle.spH + 10"
     [style.left.px]="bundle.spX + 320"
     [style.width.px]="200"
     style="position: absolute; text-align: center;">
  <span>Sign and Save BBC</span>
</div>

<div class="wordBtn"
     *ngIf="bundle.function === 'bbc' && bundle.canDelete && bundle.LOANMODELBBCRECORDID != 0 && !bundle.signed_BBC && !bundle.approved_BBC"
     (click)="openSignaturePopup('delete')"
     [style.top.px]="bundle.spY + bundle.spH + 10"
     [style.left.px]="bundle.spX + bundle.spW - 300"
     [style.width.px]="100"
     style="position: absolute; text-align: center;">
  <span>Delete BBC</span>
</div>
</div>
